module.exports = __webpack_public_path__ + "img/Companii.3d0f59fe.png";